import * as Yup from 'yup';

import { ShareDocumentSubject } from './share-document.form.enum';

export const shareDocumentValidationSchema = Yup.object().shape({
  to: Yup.array().of(Yup.object()).min(1).required().label('To'),
  subject: Yup.string()
    .oneOf(['REQUEST_APPROVAL', 'SHARE_DOCUMENT'])
    .required()
    .label('Subject'),
  message: Yup.string().label('Message'),
  sendCopy: Yup.boolean().label('Send email copy to myself'),
});

export const SUBJECTS = [
  ShareDocumentSubject.SHARE_DOCUMENT,
  ShareDocumentSubject.REQUEST_APPROVAL,
];

export const subjectToString = (value: any) =>
  value === ShareDocumentSubject.REQUEST_APPROVAL
    ? 'Requesting approval'
    : 'Sharing this document';
